import { deviceAction } from "app/store/devices/actions/deviceAction";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  shouldRefetch: false,
};

const deviceSlice = createSlice({
  name: "device",
  initialState: initialState,
  reducers: deviceAction,
});

export const { refetchDeviceList } = deviceSlice.actions;

export default deviceSlice.reducer;
